import { Navigate } from 'react-router-dom';

import { RedirectWithParams } from '@/components/router/redirect-with-params';

export const billingOrderRoutes = [
  {
    path: 'billing-orders',
    children: [
      { index: true, element: <Navigate to="../orders/billing" replace /> },
      { path: 'list', element: <Navigate to="../orders/billing" replace /> },
      { path: 'new', element: <Navigate to="../orders/billing/new" replace /> },
      { path: ':id/edit', element: <RedirectWithParams to="../orders/billing/:id/edit" /> },
      {
        path: ':orderId/information',
        element: <RedirectWithParams to="../orders/billing/:orderId/information" />,
      },
    ],
  },
];
